import { useMemo, useState } from "react";
import {
  DAY_LABELS,
  MONTH_LABELS,
  getDaysOfMonth,
  toDateStr,
} from "../../utils";
import NavControls from "./NavControls";
import SlotCard from "./SlotCard";

export default function MonthView({
  slots = [],
  currentDate,
  setCurrentDate,
  onCardClick,
  onRegisterClick,
  onCardDelete,
}) {
  const [selectedDay, setSelectedDay] = useState(null);
  const currentDt = new Date(currentDate);
  const year = currentDt.getFullYear();
  const month = currentDt.getMonth();

  const days = getDaysOfMonth(year, month);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const goMonth = (dir) => {
    const d = new Date(currentDate);
    d.setMonth(d.getMonth() + dir);
    d.setDate(1);
    setCurrentDate(d);
    setSelectedDay(null);
  };

  const selectedDateStr = selectedDay ? toDateStr(selectedDay) : null;

  const selectedSlots = useMemo(() => {
    if (!selectedDateStr) return [];
    return slots
      .filter((s) => s.slot_date === selectedDateStr)
      .sort((a, b) => (a.start_time || "").localeCompare(b.start_time || ""));
  }, [slots, selectedDateStr]);

  return (
    <div className="month-view">
      {/* Navigation */}
      <div className="month-nav">
        <NavControls
          label={`${MONTH_LABELS[month]} ${year}`}
          onPrev={() => goMonth(-1)}
          onNext={() => goMonth(1)}
        />
      </div>

      {/* Day labels */}
      <div className="month-day-labels">
        {DAY_LABELS.map((d) => (
          <div key={d} className="month-day-label">
            {d}
          </div>
        ))}
      </div>

      {/* Calendar grid */}
      <div className="month-grid">
        {days.map((day, i) => {
          const dateStr = toDateStr(day);
          const daySlots = slots.filter((s) => s.slot_date === dateStr);

          const isToday = day.getTime() === today.getTime();
          const isCurrentMonth = day.getMonth() === month;
          const isSelected = selectedDateStr === dateStr;

          return (
            <div
              key={i}
              className={[
                "month-day",
                isSelected && "selected",
                !isCurrentMonth && "outside",
              ]
                .filter(Boolean)
                .join(" ")}
              onClick={() => isCurrentMonth && setSelectedDay(day)}
            >
              <div className={`month-day-number ${isToday && "today"}`}>
                {day.getDate()}
              </div>

              <div className="month-day-slots">
                {daySlots.slice(0, 5).map((slot) => (
                  <div
                    key={slot.id}
                    className="month-slot-bar"
                    data-type={slot.event.event_type}
                  />
                ))}

                {daySlots.length > 5 && (
                  <div className="month-slot-more">+{daySlots.length - 5}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Detail panel */}
      <div className="month-detail card">
        {selectedDay ? (
          <>
            <div className="calendar-header card-header">
              <div className="card-title">
                <h3 className="card-title-text">
                  {DAY_LABELS[
                    selectedDay.getDay() === 0 ? 6 : selectedDay.getDay() - 1
                  ].toLowerCase()}{" "}
                  {selectedDay.getDate()} {MONTH_LABELS[selectedDay.getMonth()]}{" "}
                  {selectedDay.getFullYear()}
                </h3>

                <span className="count-badge">
                  {selectedSlots.length} créneau
                  {selectedSlots.length !== 1 ? "x" : ""}
                </span>
              </div>

              <div className="card-actions">
                <button
                  className="month-detail-close"
                  onClick={() => setSelectedDay(null)}
                >
                  ×
                </button>
              </div>
            </div>

            <div className="month-detail-body card-body">
              {selectedSlots.length > 0 ? (
                selectedSlots.map((slot) => (
                  <SlotCard
                    key={slot.id}
                    slot={slot}
                    onCardClick={onCardClick}
                    onRegisterClick={onRegisterClick}
                    onDeleteClick={onCardDelete}
                  />
                ))
              ) : (
                <div className="info-banner info">Aucun créneau ce jour</div>
              )}
            </div>
          </>
        ) : (
          <div className="month-detail-placeholder info-card">
            <div className="info-card-body">
              <div className="info-icon">📅</div>
              <p className="info-value">
                Sélectionnez un jour pour voir les créneaux
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
